<div class="languages">
  <span *ngIf="isTitleVisible">{{ 'header.language' | translate }}:</span>

  <ul class="languages-list" [ngClass]="{ 'mobile-menu': isMobileMenu }">
    <li
      *ngFor="let lang of APP_LANGUAGE | keyvalue"
      (click)="changeLanguage(lang.value)"
      [class.active]="currentLang === lang.value"
      [ngClass]="{ 'short-name': isNameVisible && isNameShort }">
      @if (isNameVisible && isNameShort) {
        {{ lang.value | uppercase }}
      }
      <img [src]="'./assets/images/' + lang.value.toLowerCase() + '.svg'" [alt]="lang.value" [title]="'language.' + lang.value | translate" />
      @if (isNameVisible && !isNameShort) {
        {{ 'language.' + lang.value | translate }}
      }
    </li>
  </ul>
</div>
